<template>
  <div class="">

    <user-integration-record-input-filters
        @filters-changed="filtersUpdated">
    </user-integration-record-input-filters>

    <div v-if="isLoading">
      <loader></loader>
    </div>
    <slot v-if="!isLoading && list.data.length > 0">
      <div class="min-w-full">
        <pagination @page="setPage" :meta="list.meta"></pagination>
      </div>

      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden border-t border-gray-200">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
              <tr>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contact Name
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contact Email
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Contact Country
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Description
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Type
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase text-center tracking-wider text-right">
                  Currency
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase text-center tracking-wider text-right">
                  Total
                </th>
                <th scope="col"
                    class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase text-center tracking-wider">
                  Status
                </th>
                <th scope="col" class="relative px-6 py-3 text-right">
                  <span class="sr-only">View</span>
                </th>
              </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
              <tr
                  class="cursor-pointer"
                  v-for="item in list.data"
                  @click.prevent="() => rowClicked(item)">
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ contactName(item) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ contactEmail(item) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ contactCountry(item) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ item.transaction_description }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ item.transaction_type }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ asLocalTime(item.transaction_date) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  {{ item.transaction_currency }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right">
                  <div class="" :class="item.transaction_total > 0 ? 'text-green-600' : 'text-red-600'">
                    {{ asMoney(item.transaction_total, item.transaction_currency) }}
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class=" flex justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 20 20"
                         fill="currentColor"
                         aria-hidden="true"
                         class="flex-shrink-0 mr-1.5 h-5 w-5 text-green-400"
                         v-if="item.user_integration_record_output_id">
                      <path fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                            clip-rule="evenodd"></path>
                    </svg>
                    <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fad"
                        data-icon="times-circle"
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-red-400"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512" v-else>
                      <g class="fa-group">
                        <path class="fa-secondary" fill="currentColor"
                              d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"
                              opacity="0.4"></path>
                        <path class="fa-primary" fill="currentColor"
                              d="M377.6 321.1a12 12 0 0 1 0 17L338 377.6a12 12 0 0 1-17 0L256 312l-65.1 65.6a12 12 0 0 1-17 0L134.4 338a12 12 0 0 1 0-17l65.6-65-65.6-65.1a12 12 0 0 1 0-17l39.6-39.6a12 12 0 0 1 17 0l65 65.7 65.1-65.6a12 12 0 0 1 17 0l39.6 39.6a12 12 0 0 1 0 17L312 256z"></path>
                      </g>
                    </svg>
                  </div>
                </td>

                <td
                    @click.prevent="() => viewTransaction(item.id)"
                    class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">

                  <a href="#" class="text-indigo-600 hover:text-indigo-900">
                    View
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="min-w-full">
        <pagination @page="setPage" :meta="list.meta"></pagination>
      </div>
    </slot>

    <slot name="no-results" v-if="!isLoading && list.data.length === 0">
      <h1>No results</h1>
    </slot>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Loader from "@/components/Loader";
import {formatMoney} from 'accounting-js';
import Pagination from "@/components/Pagination/Pagination";
import UserIntegrationRecordInputFilters
  from "@/components/UserIntegrationRecordInputs/UserIntegrationRecordInputFilters";

const moment = require("moment-timezone");

export default {
  name: "ListUserIntegrationRecordInput",

  components: {UserIntegrationRecordInputFilters, Pagination, Loader},

  props: {
    filter: {
      type: Object
    },
    record: {
      type: Object
    }
  },

  created() {
    this.loadList()
  },

  methods: {

    filtersUpdated(filter) {
      this.searchForm = {filter};
      this.loadList();
    },

    setPage(page) {
      return this.loadList({
        page: {
          number: page
        }
      })
    },

    asLocalTime(datetime) {
      let parsedTime = null;

      if (this.record.input_timezone) {
        parsedTime = moment(datetime).tz(this.record.input_timezone)
      } else {
        parsedTime = moment(datetime)
      }

      return parsedTime
          .format('MMM Do, YYYY hh:mm:ss A')
    },

    asMoney(money, currency) {
      return formatMoney(money, {symbol: currency, format: "%v"});
    },

    loadList(params = {}) {
      let filterParams = Object.assign(
          {},
          this.inputFilters,
          this.searchForm,
          params
      );

      this.$store.dispatch(
          'user_integration_record_inputs/readList',
          filterParams
      )
    },

    rowClicked(item) {
      this.viewTransaction(item.id)
    },

    viewTransaction(id) {
      this.$router.push({
        name: 'user_integration_settings_view_input',
        params: {
          settings_id: this.record.id,
          input_id: id
        }
      })
    },

    contactName(item) {
      if (!item.contact) {
        return '--'
      }
      const first_name = item.contact.data.first_name || ''
      const last_name = item.contact.data.last_name || ''

      return first_name + ' ' + last_name;
    },

    contactEmail(item) {
      if (!item.contact) {
        return '--'
      }

      return item.contact.data.email;
    },

    contactCountry(item) {
      if (!item.contact) {
        return '--'
      }

      return item.contact.data.country;
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'user_integration_record_inputs/getIsLoadingList',
      list: 'user_integration_record_inputs/getList'
    })
  }
}
</script>

<style scoped>

</style>